import { produce } from 'immer';

import type { ProjectConfigInput } from '#core/schema/ProjectConfigSchema';
import { theme } from '#core/themes/futuristic'; // FIXME: theme packages

import faviconUrl from '#assets/adnoc-favicon.svg';
import { AdnocLogo } from '#components/AdnocLogo';

export const config = {
  id: 'adnoc-scale',
  name: 'ADNOC Scale Dashboard',
  logo: AdnocLogo,
  faviconUrl,
  defaultColorScheme: 'dark',
  debug: { devtools: { enabled: false } },
  theme: produce(theme, (draft) => {}),
  feature: { ai: { enabled: true } },
} as const satisfies ProjectConfigInput;
